import React from 'react';
import {
  AssessmentOutlined,
  EmojiPeopleOutlined,
  AssignmentTurnedInOutlined,
  InsertCommentOutlined,
} from '@mui/icons-material';
import { Link, useParams, useLocation } from 'react-router-dom';

import { Container, Content, BoxCard } from './styles';

interface Project {
  name: string;
  customerId: number;
  startYear: string;
  startMonth: string;
}
interface State {
  project: Project;
}

const ProjectDashboard: React.FC = () => {
  const { projectId } = useParams();
  const location = useLocation();
  const state = location.state as State;

  return (
    <Container>
      <h1>{state?.project?.name}</h1>

      <Content>
        <BoxCard>
          <Link
            to={`/surveys/project/${projectId}`}
            state={{ projectName: state?.project?.name }}
          >
            <AssignmentTurnedInOutlined />
            <h3>Surveys</h3>
          </Link>
        </BoxCard>

        <BoxCard>
          <Link to={`/projects/${projectId}/participation`}>
            <EmojiPeopleOutlined />
            <h3>Participations</h3>
          </Link>
        </BoxCard>

        <BoxCard>
          <Link
            to={`/projects/${projectId}/analytics`}
            state={{ project: state?.project }}
          >
            <AssessmentOutlined />
            <h3>Analytics</h3>
          </Link>
        </BoxCard>

        <BoxCard>
          <Link
            to={`/projects/${projectId}/openAnswers`}
            state={{ project: state?.project }}
          >
            <InsertCommentOutlined />
            <h3>Open Answers</h3>
          </Link>
        </BoxCard>
      </Content>
    </Container>
  );
};

export default ProjectDashboard;
